import React from 'react'
import Switch from '@material-ui/core/Switch'

export const SwitchUnstyled = ({ className, input = {}, ...others }) => {
  // backwards compatibility
  var value = 'value' in others ? others.value : input.value
  return (
    <div className={className} cypress_id={others.cypress_id}>
      <Switch checked={value} {...input} {...others} />
      <label htmlFor={others.id}>{others.label || ''}</label>
    </div>
  )
}
